<template>
  <section class="layout-section -no-top">
    <template v-if="attachments.length">
      <h3 class="publication-single__heading">Pièces jointes</h3>

      <a v-for="file in attachments" :key="file" :href="file" target="_blank" class="article-pdf -accent">
        <div class="article-pdf__info">
          <div class="article-pdf__figure -accent">
            <SvgIcon id="file-pdf" />
          </div>

          <span>{{ getFileName(file) }}</span>
        </div>

        <div class="article-pdf__info -alt">
          <SvgIcon id="file-download" />
        </div>
      </a>
    </template>

    <template v-if="keywords.length">
      <h3 class="publication-single__heading">Mots-clés</h3>

      <div class="navigation-search__filters">
        <RouterLink
          v-for="{ slug, label } in keywords"
          :key="slug"
          :to="{ name: 'publication-index', query: { ...$route.query, keywords: [slug] } }"
          class="navigation-search__tags tag -light"
          exact
        >
          {{ label }}
        </RouterLink>
      </div>
    </template>
  </section>
</template>

<script>
export default {
  name: 'PublicationSingleMore',
  props: {
    publication: {
      type: Object,
      default: null
    }
  },
  computed: {
    attachments() {
      const attachments = this.publication.attachments || []
      const documents = this.publication.documents || []
      return [...attachments, ...documents].map(({ fileUrl }) => fileUrl).filter(Boolean)
    },
    keywords() {
      if (!this.publication.keywords || !this.publication.keywords.length) return []

      return this.publication.keywords.map(keywordId => {
        const keyword = this.$wp.keywordsById[keywordId]
        return { slug: keyword.slug, label: keyword.name }
      })
    }
  },
  methods: {
    getFileName(attachment) {
      return attachment.split('/').pop() || ''
    }
  }
}
</script>
